import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import MindUpAdminMobileAllReservationConsultationHeader from './MindUpAdminMobileAllReservationConsultationHeader';
import { useDiagnosisListByStatusQuery } from 'api/Queries/Diagnosis/useDiagnosisListByStatusQuery';
import { IDDiagnosis } from 'models/DCK/basicInterface';
import { ReservationType } from 'models/MindUpAdmin/MindupAdminUserReservationConsultationPageTypes';
import { useLoginStore } from 'store/useLoginDataStore';
import { DiagnosisStatus } from 'utils/statusCode';
import { SendSmsType } from 'models/PreciousChild/sendSmsApiTypes';
import { formatDateString } from 'utils/calculateTime';
import useToggle from 'hooks/CustomHooks/useToggle';
import { Body5Medium, Body5SemiBold } from 'styles/Global/typography';
import { TextColor } from 'styles/Global/colorSemantic';
import { Request, SurveyEnd } from 'components/CounselingCards/CounselingCards';
import { NothingDataInMindUpAdminMobileAllReservationConsultationPage } from 'pages/Admin/DCK/AddDiagnosisPage/NothingDataInPagination';
import ConfirmDialogueSimpleInfo from 'components/DesignSystem/MobileConfirmDialogue/ConfirmDialogueSimpleInfo';
import useUpdateAssignCounselor from 'api/Mutations/Diagnosis/useUpdateAssignCounselor';
import useDiagnosisChangeStatusMutation from 'api/Mutations/Diagnosis/useDiagnosisChangeStatusMutation';
import useMindUpSendSMSMutation from 'api/Mutations/SMS/useMindUpSendSMSMutation';
import { mindupAdminMobilePaths } from 'constants/path';
import { useNavigate } from 'react-router-dom';
import MindUpAdminMobileMenu from 'components/Menu/MindUpAdminMobileMenu';
import { AssignCounselorRqData } from 'models/MindUp/MindUpTypes';
import { resetScrollPosition } from 'components/Common/ScrollToTop';

const MindUpAdminMobileAllReservationConsultationPage = () => {
    const { loginData } = useLoginStore();
    const navigate = useNavigate();

    // 0: 전체, 1: 요청 전, 2: 예약 대기
    const [menu, setMenu] = useState<number>(0);
    const [initData, setInitData] = useState<IDDiagnosis[]>();
    const [filterData, setFilterData] = useState<IDDiagnosis[] | undefined>(initData);
    const [counselData, setCounselData] = useState<ReservationType>();
    const [isSwiping, setIsSwiping] = useState(false);

    const [onShowReservationAlert, setOnShowReservationAlert] = useToggle();
    const [onMenu, setOnMenu] = useToggle();

    const { data: diagnosisListData, isLoading: diagnosisListLoading, refetch: refetchDiagnosisListData } = useDiagnosisListByStatusQuery({ status: [3] }, menu);
    const { mutate: updateAssignCounselor } = useUpdateAssignCounselor();
    const { mutate: changeStatus } = useDiagnosisChangeStatusMutation();
    const { mutate: sendSMS } = useMindUpSendSMSMutation();

    const touchStartRef = useRef(0);
    const touchThreshold = 50; // 스와이프로 인식할 최소 거리(px)

    // IOS에서 스와이프 감지
    useEffect(() => {
        resetScrollPosition();
    }, [menu]);

    useEffect(() => {
        processDiagnosisData();
    }, [diagnosisListData]);

    // 데이터 처리 함수
    const processDiagnosisData = () => {
        if (!diagnosisListData) return;

        const beforeRequestList = (counselItem: IDDiagnosis) => counselItem.counselDateTimeList.length === 0;
        const waitingList = (counselItem: IDDiagnosis) => counselItem.counselDateTimeList.length > 0;

        // pagination menu에 따라 filtering
        const sortedData =
            menu !== 0 ? diagnosisListData.filter(menu === 1 ? beforeRequestList : waitingList).sort((a, b) => b.timestamp - a.timestamp) : diagnosisListData.sort((a, b) => b.timestamp - a.timestamp);

        setInitData(sortedData);
        setFilterData(sortedData);
    };

    // Reservation Alert Modal Leave Button
    const reservationModalConfirm = async () => {
        const rqData: AssignCounselorRqData = {
            diagnosisId: counselData?.diagnosisId ?? '',
            userId: loginData.id,
            counselDateTime: counselData?.reservationDate ?? '',
        };

        const changeStatusRqData = {
            _id: counselData?.diagnosisId ?? '',
            status: DiagnosisStatus.counselReserved,
        };
        try {
            updateAssignCounselor(rqData, {
                onSuccess: async () => {
                    changeStatus(changeStatusRqData, {
                        onSuccess: (res) => {
            //                 const rqData: SendSmsType = {
            //                     receiveNum: res.patientMobile,
            //                     receiveName: res.parentName,
            //                     contents: `[마인드업] 상담 확정 안내\n\n${
            //                         res.parentName
            //                     }님!\n요청하신 자녀 심리분석 상담이 확정되었습니다.\n(상담은 총 20분간 전화로 진행됩니다.)\n\n확정된 시각에 상담사가 전화드립니다.\n놓치지 마시고, 전화를 꼭 받아주세요!\n\n---------------------\n\n상담 일정\n▶${formatDateString(
            //                         res.diagnosisDateTime
            //                     )}\n\n---------------------\n\n검사 결과가 궁금하다면, https://tlcdoctors.co.kr/mindup/enterance 에서 검사 코드를 입력하고 미리 확인해보세요.
            
            // TLC 문의 : 031-717-1400`,
            //                 };
            //                 sendSMS(rqData, {
            //                     onSuccess: () => {
            //                         setCounselData({ diagnosisId: '', reservationDate: '' });
            //                         localStorage.setItem('snackbar', 'true');
            //                         navigate(mindupAdminMobilePaths.mindUpAdminMobileDetailDiagnosis, {
            //                             state: res,
            //                         });
            //                     },
            //                 });
                        setCounselData({ diagnosisId: '', reservationDate: '' });
                            localStorage.setItem('snackbar', 'true');
                            navigate(mindupAdminMobilePaths.mindUpAdminMobileDetailDiagnosis, {
                                state: res,
                            });
                        },
                    });
                },
            });
        } catch (error) {
            console.error('Error during mutation:', error);
        }
    };

    const selectDate = (counselData: ReservationType) => {
        setCounselData(counselData);
        setOnShowReservationAlert();
    };

    const cancelButton = () => {
        setCounselData({ diagnosisId: '', reservationDate: '' });
        setOnShowReservationAlert();
    };

    // 터치 시작 감지
    const handleTouchStart = (e: any) => {
        touchStartRef.current = e.touches[0].clientX;
        setIsSwiping(true);
    };

    // 터치 종료 처리
    const handleTouchEnd = (e: any) => {
        if (!isSwiping) return;

        const touchEnd = e.changedTouches[0].clientX;
        const distance = touchEnd - touchStartRef.current;

        // 충분한 거리를 스와이프했을 때만 탭 변경
        if (Math.abs(distance) > touchThreshold) {
            if (distance > 0 && menu > 0) {
                // 오른쪽으로 스와이프 - 이전 탭
                setMenu(menu - 1);
            } else if (distance < 0 && menu < 2) {
                // 탭 개수에 맞게 조정
                // 왼쪽으로 스와이프 - 다음 탭
                setMenu(menu + 1);
            }
        }

        setIsSwiping(false);
    };

    return (
        <>
            {onMenu && <MindUpAdminMobileMenu close={setOnMenu} />}
            <MindUpAdminMobileAllReservationConsultationHeader menu={menu} setMenu={setMenu} onClick={setOnMenu} />
            <Layout>
                {onShowReservationAlert && (
                    <ConfirmDialogueSimpleInfo
                        title='이 일시로 상담을 확정할까요?'
                        content='상담 일시를 확정하면 더 이상 수정이 불가능합니다. 일정을 확인하고 확정해주세요.'
                        counselData={counselData}
                        firstButton='취소'
                        secondButton='상담 확정'
                        clickFirstButton={cancelButton}
                        clickSecondButton={reservationModalConfirm}
                    />
                )}

                <SwipeContainer onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
                    {!filterData || filterData?.length === 0 ? (
                        <NothingDataInMindUpAdminMobileAllReservationConsultationPage />
                    ) : (
                        <>
                            <ReservationCount>
                                <Count>{filterData?.length}</Count>건의 상담
                            </ReservationCount>
                            <CardListContainer>
                                {filterData?.map((item, idx) =>
                                    !item.counselDateTimeList || item.counselDateTimeList.length === 0 ? (
                                        <SurveyEnd key={idx} diagnosisInfo={item} />
                                    ) : (
                                        <Request key={idx} diagnosisInfo={item} onClick={selectDate} />
                                    )
                                )}
                            </CardListContainer>
                            {filterData?.length !== 0 && <BottomSpace />}
                        </>
                    )}
                </SwipeContainer>
            </Layout>
        </>
    );
};

export default MindUpAdminMobileAllReservationConsultationPage;
const SwipeContainer = styled.div`
    width: 100%;
    height: 100%;
`;

const Layout = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    height: auto;
    padding-top: 96px;
`;

const Count = styled(Body5SemiBold)`
    color: ${TextColor.color_text_light};
    font-weight: 600;
`;

const ReservationCount = styled(Body5Medium)`
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 40px;
    height: 40px;
    padding: 0 18px;
    background-color: white;
    color: ${TextColor.color_text_light};
`;

const CardListContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 14px;
    padding: 0 16px;
`;

const BottomSpace = styled.div`
    width: 100%;
    height: 56px;
    flex-shrink: 0;
`;
